module.exports = __webpack_public_path__ + "media/images/program/ebt_journey-8f7c509897adbd13597c8a425b47f9f523643548202542e4cb0fc15e0b4bca90.png";